import { Card, Col, Row, Steps } from "antd";
import Layout from "antd/lib/layout/layout";
import React from "react";

import EducationTitle from "./EducationTitle";

const { Step } = Steps;
const Education = () => {
  return (
    <Layout>
      <EducationTitle />

      <Row justify="center" style={{ padding: "4rem 0" }}>
        <Col xs={23} sm={23} md={12} lg={12} xl={10} xxl={10}>
          <Card title="Academic Qualification" style={{ height: "100%" }}>
            <Steps progressDot current={1} direction="vertical">
              <Step
                title="Green University of Bangladesh"
                subTitle=" Current"
                description="Bachelors of Computer Science & Engineering I am currently reading Bachelors of Computer Science & Engineering, green university of bangladesh"
              />
              <Step
                title="Thakurgaon Polytechnic Institute"
                subTitle="Passed"
                description="Diploma In Computer Engineering Technology The education is based on computer science. After successfully completing a Diploma in Computer Engineering  Technology. "
              />
            </Steps>
          </Card>
        </Col>

        <Col xs={23} sm={23} md={12} lg={12} xl={10} xxl={10}>
          <Card title="COURSE " style={{ height: "100%" }}>
            <Steps progressDot current={1} direction="vertical">
              <Step
                title="Programming-Hero"
                subTitle="Current"
                description="During the Corona pandemic time, I have gained a good sound in Javascript, React,
                NodeJS, ExpressJS, Node, MongoDB. In this course, We have the best instructor Jhankar Mahbub. Also, I
                have worked on a project with a team in the course I am very Grateful To Enjoy Personalized, Fun, And
                Interactive Learning Process While Becoming A Mern-stack Developer."
              />
              <Step
                title="Creative It Institute"
                subTitle="Finish"
                description="I have learned this very well. I received the award as the best student while studying here , I took this course as an intern in the last semester of my diploma. The course gives me a good knowledge of Php , Laravel. I Have Learned This Very Well. I Received The Award As The Best Student While Studying Here Back-End Developer."
              />
            </Steps>
          </Card>
        </Col>
      </Row>
    </Layout>
  );
};

export default Education;
